<template>
  <div class="relative flex items-center justify-center w-full h-12 space-x-8 text-base font-bold xl:text-lg 2xl:text-xl xl:h-20">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'PageMenu',
}
</script>

<style>

</style>
